import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control, Errors, actions } from 'react-redux-form';
import { keys } from 'lodash';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import SelectComponent from './SelectComponent';
import {
  Modal,
  Button,
  FormGroup,
  ControlLabel
} from 'react-bootstrap';
import { annotation as constants } from './../helpers';

let comment = '';

export default class AddCommentModalComponent extends React.Component {
  static propTypes = {
    visible: PropTypes.bool,
    ticketOverridesStatus: PropTypes.bool,
    statusList: (props, propName, componentName) => {
      const sList = props[propName];
      if (sList.length < 1) return new Error(
        'Invalid prop: statusList must not be empty, supplied to ' + componentName
      );
      if (props['ticketOverridesStatus'] &&
       sList.filter( s => s.displayStatus ===
         constants.ALL_ANNOTATIONS_STATUSES.TICKET_FILED).length !== 1)
      { return new Error ('Ticket filed status is missing in statusList'); }
      if (!props['ticketOverridesStatus'] &&
       sList.filter( s => s.displayStatus ===
        constants.ALL_ANNOTATIONS_STATUSES.TICKET_FILED).length === 1)
      { return new Error ('Ticket filed status should not be in statusList'); }
      if (sList.some(s => {
        if (!s.displayStatus ||
           !keys(constants.ALL_ANNOTATIONS_STATUSES).
             map(key => constants.ALL_ANNOTATIONS_STATUSES[key])
             .includes(s.displayStatus)) return true;
      })) return new Error('Invalid prop: statusList supplied to ' + componentName);
    },
    ticketStatusFunc: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  _validateTicket(ticket) {
    if (!ticket) return true;
    const ticketRegex = /^[a-zA-Z]{2,5}-\d{1,5}$/;
    return ticketRegex.test(ticket);
  }

  _setComment(value) {
    comment = value;
  }

  attachDispatch = (dispatch) => this.formDispatch = dispatch;

  submitShortcut() {
    this.formDispatch(
      actions.submit('info'));
  }

  render() {
    const {
      visible,
      ticketOverridesStatus,
      statusList,
      onHide,
      onSubmit
    } = this.props;

    const initialState = {
      userName: localStorage.getItem('userName') || '',
      status: statusList[0].displayStatus,
      ticket: '',
      comment: ''
    };

    return (
      <Modal show={visible} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Add Comment</Modal.Title>
        </Modal.Header>
        <KeyboardEventHandler
          id="keyListener"
          handleKeys={['ctrl+enter']}
          onKeyEvent={() => { this.submitShortcut(); }}
        >
          <LocalForm
            id="add-comment-form"
            model="info"
            getDispatch={dispatch => this.attachDispatch(dispatch)}
            validators={{
              '' : {
                ticket: val => {
                  return this._validateTicket(val.ticket);
                }
              }
            }}
            onSubmit={onSubmit}
            onChange={model => {
              this._setComment(model.comment);
              this.setState(
                { ...model }
              ); }}
            initialState={initialState}
          >
            <Modal.Body>
              <FormGroup controlId="status">
                <ControlLabel>Status</ControlLabel>
                <Control.custom
                  id="status-input"
                  component={SelectComponent}
                  className="form-control"
                  model="."
                  type="hidden"
                  mapProps={({ modelValue, onChange }) => {
                    const ticket = this._validateTicket(modelValue.ticket) &&
                      modelValue.ticket;
                    return {
                      options: statusList.map(s => s.displayStatus),
                      selected: this.props.ticketStatusFunc(ticket),
                      onChange: d => onChange({
                        ...modelValue,
                        status: d
                      }),
                    };
                  }}
                />
              </FormGroup>
              <FormGroup controlId="userName">
                <ControlLabel>Your Name</ControlLabel>
                <Control
                  id="username-input"
                  className="form-control"
                  model=".userName"
                  type="text"
                  placeholder="Please log into Jira and then submit your comment."
                  disabled
                  validators={{ userName: val => !!val.length }}
                />
                <Errors
                  className="popover-bottom"
                  model=".userName"
                  show="touched"
                  messages={{ userName: 'Invalid userName' }}
                />
              </FormGroup>
              <FormGroup controlId="ticket">
                <ControlLabel>Ticket Number</ControlLabel>
                <Control.custom
                  id="ticket-input"
                  className="form-control"
                  model="."
                  type="text"
                  placeholder="A ticket number. (ex. IEF-1234) (Optional)."
                  mapProps={({ modelValue, onChange }) => {
                    return {
                      onChange: d => onChange({
                        ...modelValue,
                        ticket: d.target.value ? d.target.value.toUpperCase() : '',
                        status: d.target.value && ticketOverridesStatus ?
                          constants.ALL_ANNOTATIONS_STATUSES.TICKET_FILED :
                          modelValue.status
                      }),
                    };
                  }}
                />
                <Errors
                  className="popover-bottom"
                  model="."
                  messages={{ ticket: 'Invalid ticket name.' }}
                />
              </FormGroup>
              <FormGroup controlId="comment">
                <ControlLabel>{`Comment (${256 - comment.length})`}</ControlLabel>
                <Control.textarea
                  id="comment-input"
                  className="form-control"
                  model=".comment"
                  validators={{ comment: val => val.length <= 256 }}
                  type="text"
                  rows={4}
                  autoFocus
                  placeholder="Please enter a comment. (Optional)."
                  mapProps={({ modelValue, onChange }) => {
                    return {
                      value: modelValue.comment,
                      onChange: d =>
                        onChange({
                          ...modelValue,
                          comment: d.target.value
                        })
                    };
                  }}
                />
                <Errors
                  className="popover-bottom"
                  model=".comment"
                  show="touched"
                  messages={{ comment: 'comment has exceeded 256 charaters' }}
                />
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={onHide}>Cancel</Button>
              <Button
                id="submit-btn"
                bsStyle="primary"
                type="submit"
              >
                {'Comment (Ctrl+Enter)'}
              </Button>
            </Modal.Footer>
          </LocalForm>
        </KeyboardEventHandler>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/AddCommentModalComponent.jsx